 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({"view-About-vue~view-MyAccount-vue~view-SingleAwards-vue~view-SingleAwardsResults-vue~view-SingleProfile-vue":"view-About-vue~view-MyAccount-vue~view-SingleAwards-vue~view-SingleAwardsResults-vue~view-SingleProfile-vue","view-About-vue~view-SingleProfile-vue":"view-About-vue~view-SingleProfile-vue","view-About-vue":"view-About-vue","view-MyAccount-vue~view-SingleAwards-vue~view-SingleProfile-vue":"view-MyAccount-vue~view-SingleAwards-vue~view-SingleProfile-vue","view-MyAccount-vue":"view-MyAccount-vue","view-Academy-vue":"view-Academy-vue","view-Awards-vue~view-AwardsResults-vue~view-Disputes-vue~view-Payments-vue~view-Reviews-vue~view-Sin~1c0978d0":"view-Awards-vue~view-AwardsResults-vue~view-Disputes-vue~view-Payments-vue~view-Reviews-vue~view-Sin~1c0978d0","view-SingleProfile-vue":"view-SingleProfile-vue","view-SingleAwards-vue~view-SingleAwardsResults-vue":"view-SingleAwards-vue~view-SingleAwardsResults-vue","view-SingleAwards-vue":"view-SingleAwards-vue","view-SingleAwardsResults-vue":"view-SingleAwardsResults-vue","view-Awards-vue":"view-Awards-vue","view-AwardsResults-vue":"view-AwardsResults-vue","view-Disputes-vue":"view-Disputes-vue","view-Payments-vue":"view-Payments-vue","view-Reviews-vue":"view-Reviews-vue","view-Home-vue":"view-Home-vue","view-Lifeshare-vue":"view-Lifeshare-vue","view-Loader-vue":"view-Loader-vue","view-MemberContent-vue":"view-MemberContent-vue","view-Partners-vue":"view-Partners-vue","view-ProfilesArchive-vue":"view-ProfilesArchive-vue","view-SingleDisputes-vue":"view-SingleDisputes-vue","view-SingleReviews-vue":"view-SingleReviews-vue","view-Stamps-vue":"view-Stamps-vue"}[chunkId]||chunkId) + "." + {"view-About-vue~view-MyAccount-vue~view-SingleAwards-vue~view-SingleAwardsResults-vue~view-SingleProfile-vue":"a7db53c0","view-About-vue~view-SingleProfile-vue":"b6f39797","view-About-vue":"df2aaee2","view-MyAccount-vue~view-SingleAwards-vue~view-SingleProfile-vue":"c4681c60","view-MyAccount-vue":"e24c56d4","view-Academy-vue":"b07036df","view-Awards-vue~view-AwardsResults-vue~view-Disputes-vue~view-Payments-vue~view-Reviews-vue~view-Sin~1c0978d0":"1abccc43","view-SingleProfile-vue":"b0a8409c","view-SingleAwards-vue~view-SingleAwardsResults-vue":"0b7b7a80","view-SingleAwards-vue":"59b8fe46","view-SingleAwardsResults-vue":"24fd0f7d","view-Awards-vue":"526f53b8","view-AwardsResults-vue":"95aea952","view-Disputes-vue":"ed139a09","view-Payments-vue":"8f5b3533","view-Reviews-vue":"fc58d93e","view-Home-vue":"fbe1a3dd","view-Lifeshare-vue":"79218868","view-Loader-vue":"ab793802","view-MemberContent-vue":"81503d47","view-Partners-vue":"c7253b94","view-ProfilesArchive-vue":"e70c442a","view-SingleDisputes-vue":"4680989b","view-SingleReviews-vue":"34695205","view-Stamps-vue":"b33a76a3"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"view-About-vue~view-MyAccount-vue~view-SingleAwards-vue~view-SingleAwardsResults-vue~view-SingleProfile-vue":1,"view-About-vue~view-SingleProfile-vue":1,"view-About-vue":1,"view-MyAccount-vue~view-SingleAwards-vue~view-SingleProfile-vue":1,"view-MyAccount-vue":1,"view-Academy-vue":1,"view-SingleProfile-vue":1,"view-SingleAwards-vue~view-SingleAwardsResults-vue":1,"view-SingleAwards-vue":1,"view-SingleAwardsResults-vue":1,"view-Awards-vue":1,"view-AwardsResults-vue":1,"view-Disputes-vue":1,"view-Payments-vue":1,"view-Reviews-vue":1,"view-Home-vue":1,"view-Lifeshare-vue":1,"view-Loader-vue":1,"view-MemberContent-vue":1,"view-Partners-vue":1,"view-ProfilesArchive-vue":1,"view-SingleDisputes-vue":1,"view-SingleReviews-vue":1,"view-Stamps-vue":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({"view-About-vue~view-MyAccount-vue~view-SingleAwards-vue~view-SingleAwardsResults-vue~view-SingleProfile-vue":"view-About-vue~view-MyAccount-vue~view-SingleAwards-vue~view-SingleAwardsResults-vue~view-SingleProfile-vue","view-About-vue~view-SingleProfile-vue":"view-About-vue~view-SingleProfile-vue","view-About-vue":"view-About-vue","view-MyAccount-vue~view-SingleAwards-vue~view-SingleProfile-vue":"view-MyAccount-vue~view-SingleAwards-vue~view-SingleProfile-vue","view-MyAccount-vue":"view-MyAccount-vue","view-Academy-vue":"view-Academy-vue","view-Awards-vue~view-AwardsResults-vue~view-Disputes-vue~view-Payments-vue~view-Reviews-vue~view-Sin~1c0978d0":"view-Awards-vue~view-AwardsResults-vue~view-Disputes-vue~view-Payments-vue~view-Reviews-vue~view-Sin~1c0978d0","view-SingleProfile-vue":"view-SingleProfile-vue","view-SingleAwards-vue~view-SingleAwardsResults-vue":"view-SingleAwards-vue~view-SingleAwardsResults-vue","view-SingleAwards-vue":"view-SingleAwards-vue","view-SingleAwardsResults-vue":"view-SingleAwardsResults-vue","view-Awards-vue":"view-Awards-vue","view-AwardsResults-vue":"view-AwardsResults-vue","view-Disputes-vue":"view-Disputes-vue","view-Payments-vue":"view-Payments-vue","view-Reviews-vue":"view-Reviews-vue","view-Home-vue":"view-Home-vue","view-Lifeshare-vue":"view-Lifeshare-vue","view-Loader-vue":"view-Loader-vue","view-MemberContent-vue":"view-MemberContent-vue","view-Partners-vue":"view-Partners-vue","view-ProfilesArchive-vue":"view-ProfilesArchive-vue","view-SingleDisputes-vue":"view-SingleDisputes-vue","view-SingleReviews-vue":"view-SingleReviews-vue","view-Stamps-vue":"view-Stamps-vue"}[chunkId]||chunkId) + "." + {"view-About-vue~view-MyAccount-vue~view-SingleAwards-vue~view-SingleAwardsResults-vue~view-SingleProfile-vue":"c06d9aac","view-About-vue~view-SingleProfile-vue":"5ab17a2f","view-About-vue":"6324409e","view-MyAccount-vue~view-SingleAwards-vue~view-SingleProfile-vue":"db9c436a","view-MyAccount-vue":"eb8458a4","view-Academy-vue":"a809214d","view-Awards-vue~view-AwardsResults-vue~view-Disputes-vue~view-Payments-vue~view-Reviews-vue~view-Sin~1c0978d0":"31d6cfe0","view-SingleProfile-vue":"d2a0fe21","view-SingleAwards-vue~view-SingleAwardsResults-vue":"d31f18df","view-SingleAwards-vue":"16df5424","view-SingleAwardsResults-vue":"c412b32e","view-Awards-vue":"d09eaae0","view-AwardsResults-vue":"67c1f92b","view-Disputes-vue":"7f945c3a","view-Payments-vue":"e580b3a5","view-Reviews-vue":"46137df0","view-Home-vue":"2c5fafcb","view-Lifeshare-vue":"4953fe5a","view-Loader-vue":"718a802b","view-MemberContent-vue":"1a6db758","view-Partners-vue":"870f0895","view-ProfilesArchive-vue":"d2a47306","view-SingleDisputes-vue":"6377563f","view-SingleReviews-vue":"ad0cd355","view-Stamps-vue":"7e08213b"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "/dashboard/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
